import { useTranslation } from "react-i18next"
import { ChartNoAxesGantt } from "lucide-react"
import { useFeatureFlagEnabled } from "posthog-js/react"
import BaseSidebarButton from "./BaseSidebarButton"
import { TAB_TYPES } from "@/reducers/tabsSlice"
import { usePrivateAgentTarget } from "@/hooks/usePrivateAgentTarget"
import { useSidebar } from "./SidebarContext"

const TimelineSidebarButton = ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  const isTimelineEnabled = Boolean(useFeatureFlagEnabled("timeline-view"))
  const isPlannerTimelineEnabled = Boolean(
    useFeatureFlagEnabled("planner-timeline-view"),
  )
  const { onActiveChatChange } = useSidebar()
  const { openPrivateAgentChat, targetJid } =
    usePrivateAgentTarget(onActiveChatChange)

  // The planner view doesn't depend on the private-agent side panel, so it
  // only needs its own flag.
  if (isPlannerTimelineEnabled) {
    return (
      <BaseSidebarButton
        tabName={TAB_TYPES.TIMELINE}
        icon={ChartNoAxesGantt}
        activeIcon={ChartNoAxesGantt}
        tooltipText={t("app.sidebar.planner")}
        className={className}
      />
    )
  }

  if (!isTimelineEnabled || !targetJid) return null

  return (
    <BaseSidebarButton
      tabName={TAB_TYPES.TIMELINE}
      icon={ChartNoAxesGantt}
      activeIcon={ChartNoAxesGantt}
      tooltipText={t("app.sidebar.timeline")}
      className={className}
      onClick={() => void openPrivateAgentChat("TimelineSidebarButton")}
    />
  )
}

export default TimelineSidebarButton
